import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import CatingServices from '../../../services/CastingService';
import Swal from 'sweetalert2';

const AddCastingModal = ({ show, handleClose, test, item, RequestNo, storeName, data, RequestType, loginUser }) => {
    const [castingQty, setCastingQty] = useState(0);

console.log("rrere",item)
   const handleSubmit = async (e) => {
  e.preventDefault();

  const qty = Number(castingQty);

  /* ===============================
     🔒 HARD VALIDATIONS
  =============================== */

  if (!RequestType) {
    Swal.fire("Error", "Request Type missing", "error");
    return;
  }

  if (!item?.inventoryId) {
  Swal.fire(
    "Error",
    "Inventory ID not found. Please reload the page.",
    "error"
  );
  return;
}

if (!item?.masterItem) {
  Swal.fire(
    "Error",
    "Master Item ID not found. Please reload the page.",
    "error"
  );
  return;
}
  if (!qty || isNaN(qty)){
    Swal.fire({
      icon: "warning",
      title: "Invalid Quantity",
      text: "Invalid Quantity",
    });
    return;
  }

  /* ===============================
     🚀 API CALL
  =============================== */

  try {
    await CatingServices.AddCasting({
      RequestNo,
      RequestType,

      // 🔑 REQUIRED IDs
      inventory: item.inventoryId,
      masterItem: item.masterItem,

      // 📦 INFO
      partNo: item.partNo,
      description: item.description,
      unitName: item.unitName,
      storeName,
      user: loginUser,

      // 📊 QTY
      qtyRequired: item.qtyRequired,
      qtyRecived: item.qtyRecived,
      approveQty: item.approveQty,
      castingQty: qty,
    });

    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Casting Request executed successfully!",
      timer: 2000,
      showConfirmButton: false,
    });

    setCastingQty(0);

    setTimeout(() => {
      test((prev) => prev + 1);
      handleClose();
    }, 2000);

  } catch (error) {
    console.error("Casting Error:", error);

    Swal.fire({
      icon: "error",
      title: "Failed",
      text:
        error?.response?.data?.message ||
        "Failed to create casting record",
    });
  }
};


    return (
        <Modal className="fade" show={show} onHide={handleClose}>
            <form onSubmit={handleSubmit}>
                <Modal.Header>
                    <Modal.Title><i className="fas fa-edit"></i>Create Casting {RequestType} Record</Modal.Title>
                    <Button variant="" className="btn-close" onClick={handleClose}></Button>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col md="6">
                                <label>{RequestType==='MRV'?'MRV No':'MIV No'}</label>
                                <input type="text" className="form-control form-control-sm" value={RequestNo || 'N/A'} readOnly />
                            </Col>
                            <Col md="6">
                                <label>Part No.</label>
                                <input type="text" className="form-control form-control-sm" value={item?.partNo || 'N/A'} readOnly />
                            </Col>
                            <Col md="6">
                                <label>Unit</label>
                                <input type='text' className="form-control form-control-sm" value={item?.unitName} readOnly />
                            </Col>
                            <Col md="6">
                                <label>Required Qty</label>
                                <input type='text' className="form-control form-control-sm" value={item?.qtyRequired} readOnly />
                            </Col>
                            <Col md="6">
                                <label>Approved Qty</label>
                                <input type='text' className="form-control form-control-sm" value={item?.approveQty} readOnly />
                            </Col>
                            <Col md="6">
                                <label>Received Qty</label>
                                <input type='text' className="form-control form-control-sm" value={item?.qtyRecived} readOnly />
                            </Col>
                            <Col md="6">
                                <label>Casting Qty</label>
                                <input type='number' className="form-control form-control-sm" value={castingQty} onChange={(e) => setCastingQty(e.target.value)} />
                            </Col>
                            <Col md="12">
                                <label>Description</label>
                                <textarea rows="1" className="form-control form-control-sm" value={item?.description} readOnly />
                            </Col>

                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger light" onClick={handleClose}>Close</Button>
                    <Button variant="primary" type="submit">Save Changes</Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default AddCastingModal;
